// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2plzt","button":"Pagination_button__2hkWY"};